/**
 * Enum representing the different types of preview actions.
 */
var PreviewActionType;
(function (PreviewActionType) {
    PreviewActionType["EDIT_NODE"] = "oswald-editor:edit-node";
    PreviewActionType["OPEN_FRAGMENT"] = "oswald-editor:open-fragment";
    PreviewActionType["SHOW_NODE"] = "oswald-editor:show-node";
    PreviewActionType["UPDATE_NODE"] = "oswald-application:update-node";
    PreviewActionType["UPDATE_NODE_CHILDREN"] = "oswald-application:update-node-children";
})(PreviewActionType || (PreviewActionType = {}));
export { PreviewActionType, };
//# sourceMappingURL=preview-actions.js.map